import IconFont from '@meitu/xdesign-icon-font';
import { getLocaleStore } from '@/i18n/index';
import { base64Kit } from '@/utils/base64-kit';
import { imageConverter } from '@/utils/file-kit';
import { IChartLayer, IChartLayerProps, ILayerBehavior } from '@/version-types';
import ChartLayer from '../view/chart-layer';

type Behaviors = Pick<ILayerBehavior, 'render' | 'previewToImage' | 'getMenuOverlapName' | 'getMenuOverlapIcon'>;

export const createRendererBehaviors = (frameworkIdentity: string) => {
    const behaviors: Behaviors = {
        render(layer, extraProps) {
            return <ChartLayer layer={layer as IChartLayer} {...extraProps} />;
        },

        previewToImage: () => false,

        getMenuOverlapName() {
            const { $t } = getLocaleStore();
            return $t((v) => v.layers.chart);
        },

        getMenuOverlapIcon(layer) {
            const { screenshotUrl } = layer.data as IChartLayerProps;
            return (
                <div className="l-layer__icon">
                    {screenshotUrl ? (
                        <img src={imageConverter(base64Kit.getLocalUrl(screenshotUrl), 32, 100)} alt="" />
                    ) : (
                        <IconFont name="StackedColumnGraph" fontSize={16} />
                    )}
                </div>
            );
        },
    };

    return behaviors;
};
